import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import React, { useEffect, useState } from 'react'
import {useInvoice,usePut,useCurrent} from '../../hooks/'
import { MwButton, MwSpinnerButton } from '../../components/ui'
import { useDispatch } from 'react-redux'
import {updateSettings} from '../../store/settingSlice'
import SettingListItem from '../../components/settings/SettingListItem'
import { useTranslation } from 'react-i18next'

const CENTRAL_SETTINGS_SCOPE = 'global';

const QuotationSettings = ({refreshTenant,filterDefineSetting}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation('global');
    const {SETTING_QUOTE} = useInvoice()
    const [quoteSetting,setQuoteSetting] = useState(SETTING_QUOTE)
    const {data,loading,putData} = usePut()
    const {currentCompanyId,currentTenantId,currentLangId,currentSettings} = useCurrent();

    const quoteSettingArray = Object.entries(quoteSetting || {});
    const quoteSettingList =  quoteSettingArray.map(([settingName,settingValue]) =>(
        <SettingListItem
            key={settingName}
            settingName = {settingName}
            settingValue = {settingValue}
            filterDefineSetting = {filterDefineSetting}
            setGeneralSetting = {setQuoteSetting}
            generalSetting = {quoteSetting}
            currentLangId = {currentLangId}
            prefixLang = 'invoice'
            />
    ));

    useEffect(()=>{
        if(data){
            refreshTenant();
        }
    },[data, refreshTenant]);

    useEffect(() => {
        if (SETTING_QUOTE) {
            setQuoteSetting(SETTING_QUOTE);
        }
    }, [SETTING_QUOTE]);

    const saveHandler = async() => {
        if (!quoteSetting) return;
        try {
            const _data = {
                tenantId: currentTenantId,
                companyId: currentCompanyId,
                scope: CENTRAL_SETTINGS_SCOPE,
                data: {
                    invoiceSettings: currentSettings?.invoiceSettings || {},
                    generalSettings: currentSettings?.generalSettings || {},
                    quoteSettings: quoteSetting
                }
            };
            console.log(_data);
            await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,_data)
            dispatch(updateSettings({
                typeSetting : 'quote',
                value : quoteSetting
            }));
        } catch (err) {
            console.error('Failed to save quote settings:', err);
        }
    }

    if (quoteSettingArray.length === 0) {
        return <SettingsEmptyState title={t('setting.quoteSettings')} />;
    }

    return (
        <>
            <div>
                <div className='flex  justify-between items-center gap-2 text-xs text-slate-500 font-bold px-1 '>
                    <div>
                        {t("setting.quoteSettings")}:
                    </div>
                    { loading ? <MwSpinnerButton/> : <MwButton 
                                    inGroup = {true}
                                    size='sm'
                                    onClick={saveHandler}
                                    type = 'saveBtn'  >{t("setting.Save_changes")}
                                    </MwButton> }
                </div>
                <div className='p-3 my-3 rounded-lg border border-slate-200'>
                    <div className='divide-y divide-slate-100'>{quoteSettingList}</div>
                </div>
            </div>
        </>
    )
}

export default QuotationSettings
